import { render, staticRenderFns } from "./UtilityWidgetItem.vue?vue&type=template&id=39e34b48&scoped=true&"
import script from "./UtilityWidgetItem.vue?vue&type=script&lang=ts&"
export * from "./UtilityWidgetItem.vue?vue&type=script&lang=ts&"
import style0 from "./UtilityWidgetItem.vue?vue&type=style&index=0&id=39e34b48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e34b48",
  null
  
)

export default component.exports